<script lang="ts">
import { defineComponent } from 'vue'
import PageBreadcrumb from '@/components/common/PageBreadcrumb.vue'
import OrderTable from '../components/OrderTable.vue'

export default defineComponent({
  name: 'order-list',
  components: { OrderTable, PageBreadcrumb },
})
</script>

<template>
  <main class="flex-1">
    <div class="py-6">
      <div class="max-w-(--breakpoint-2xl) mx-auto">
        <PageBreadcrumb page-title="Zoznam objednávok" />
      </div>
      <order-table />
    </div>
  </main>
</template>
